import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import { Modal } from '@material-ui/core';
import { MdClose } from 'react-icons/md';
import styles from './OtherPlantPlanUploadErrorsPopup.module.css';

const Error = ({ error }) => (
  <>
    <p className={styles.errorText}> - {error?.error}</p>
    <table style={{ width: '100%', borderSpacing: 0 }}>
      <tr className={clsx(styles.errorRow, styles.bold)}>
        <td>Destination</td>
        <td>Material Number</td>
        <td>Colour Code</td>
      </tr>
      <tr key={0} className={styles.errorRow}>
        <td>{error?.destination}</td>
        <td>{error?.colourCode}</td>
        <td>{error?.materialNumber?.trim() || '(blank)'}</td>
      </tr>
    </table>
  </>
);

const OtherPlantPlanUploadErrorsPopup = ({
  open,
  handleClose,
  errors = [],
}) => {
  const buildErrorsTextFile = errorData => {
    let text = 'Following are the errors for the uploaded file \n';

    // eslint-disable-next-line no-unused-expressions
    errorData?.globalErrors?.forEach(error => {
      text += `\n${error}`;
    });

    // eslint-disable-next-line no-unused-expressions
    errorData?.rowWiseErrors?.forEach(error => {
      text += '\n';
      text += ` - ${error.error}\n`;
      text += '\n';
      text += `\t${'Destination'.padEnd(15, ' ')} ${'Material Number'.padEnd(
        20,
        ' ',
      )} \n`;
      text += `\t${error.destination.padEnd(
        15,
        ' ',
      )} ${error.materialNumber?.trim().padEnd(20, ' ')}\n`;
      text += '\n';
      text += '\n';
    });
    return text;
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="plan-upload-errors-modal"
      aria-describedby="modal view to show errors in plan upload file"
    >
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.title}>
            <NotInterestedIcon className={styles.icfail} />
            <span>
              {' '}
              Other Plant Plan Upload -{' '}
              {errors?.globalErrors?.length +
                errors?.rowWiseErrors?.length}{' '}
              Errors!
            </span>
          </div>
          <MdClose
            className={styles.cancelIcon}
            onClick={handleClose}
            data-testid="close-upload-errors-icon"
            role="button"
          />
        </div>
        <div className={styles.content}>
          <div className={styles.contentTitle}>
            Clear following errors and try again
            <a
              className={styles.downloadLink}
              href={`data:application/txt,${encodeURIComponent(
                buildErrorsTextFile(errors),
              )}`}
              download="uploadFileErrors.txt"
            >
              (Download List here)
            </a>
          </div>
          <div className={clsx(styles.errorsContainer, styles.scrollBar)}>
            {errors?.globalErrors?.map(error => (
              <span>{error}</span>
            ))}
            {errors?.rowWiseErrors?.map(error => (
              <Error error={error} />
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};

OtherPlantPlanUploadErrorsPopup.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      globalErrors: PropTypes.arrayOf(PropTypes.string),
      rowWiseErrors: PropTypes.arrayOf(
        PropTypes.shape({
          error: PropTypes.string,
          destination: PropTypes.string,
          materialNumber: PropTypes.string,
        }),
      ),
    }),
  ),
};

export default OtherPlantPlanUploadErrorsPopup;
